import { Box, Divider, Grid, Tooltip } from "@material-ui/core";
import React from "react";
import { useIsNativeApp } from "../../../../hooks/nativeApp";

interface Props {
  title: React.ReactNode;
  action?: React.ReactNode;
  tooltip?: React.ReactText;
  tab?: string;
}

export const ProfileSection: React.FC<Props> = (props) => {
  const isNativeApp = useIsNativeApp();

  return (
    <Box mt={!isNativeApp ? 4 : 0} style={{ width: props.tab === 'favorites' ? '95vw' : 'auto' }}>
      <Grid container justify="space-between" alignItems="baseline">
        <Grid item>
          <Tooltip title={props.tooltip || ""} arrow placement="top">
            <Box display="inline-block">{props.title}</Box>
          </Tooltip>
        </Grid>

        {props.action && <Grid item>{props.action}</Grid>}
      </Grid>

      <Box mt={!isNativeApp ? 2 : 0} mb={!!props.children ? 2 : 0}>
        <Divider light />
      </Box>

      {props.children}
    </Box>
  );
};
